import { Box, Card, CardContent, CardHeader, Chip, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import moment from "moment";

export default function MerchantAccountDetails({ profile }) {
    const { t } = useTranslation()
    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Account Details")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <Box display={"flex"} justifyContent="space-between">
                    <Stack spacing={3}>
                        <Typography>
                            {t("Monthly orders average")}
                        </Typography>
                        <Typography>
                            {t("Account Type")}
                        </Typography>
                        <Typography>
                            {t("Created At")}
                        </Typography>
                        <Typography>
                            {t("Phone Verified")}
                        </Typography>
                        <Typography>
                            {t("Email Verified")}
                        </Typography>
                    </Stack>
                    <Stack spacing={3} justifyContent="center" alignItems="center">
                        <Chip label={profile?.ordersRange ?? '--------'} color="primary" variant="outlined" />
                        <Chip label={t(profile?.role)} color="primary" variant="outlined" />
                        <Chip label={moment(profile?.createdAt).format("DD/MM/YYYY - hh:mm A")} color="primary" variant="outlined" />
                        {profile?.phoneVerified ? <CheckCircleIcon color="success" fontSize="small" /> : <CancelIcon color="error" fontSize="small" />}
                        {profile?.emailVerified ? <CheckCircleIcon color="success" fontSize="small" /> : <CancelIcon color="error" fontSize="small" />}
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    )
}